import { render, staticRenderFns } from "./QualificationCategoryEdit.vue?vue&type=template&id=2865250f"
import script from "./QualificationCategoryEdit.js?vue&type=script&lang=js&external"
export * from "./QualificationCategoryEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports